import React, { useState, useEffect } from "react";
import { BrowserRouter as BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollTopButton from "./components/ScrollTopButton";

import CopyViewWidgetPic from "./pages/widgets/copyViewWidgetPic";
import FilterCommentsWidgetPic from "./pages/widgets/filterCommentsWidgetPic";
import GlossaryWidgetPic from "./pages/widgets/glossaryWidgetPic";
import FileGalleryWidgetPic from "./pages/widgets/fileGalleryWidgetPic";
import ReviewCommentsWidgetPic from "./pages/widgets/reviewCommentsWidgetPic";

import Hosting from "./pages/servicesGrid/hosting";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Trainings from "./pages/Trainings";
import Contact from "./pages/Contact";

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const themeLink = document.getElementById("theme-link");
    if (!themeLink) return;

    if (darkMode) {
      themeLink.href =
        "https://unpkg.com/primereact/resources/themes/lara-dark-blue/theme.css";
      document.body.classList.add("dark-mode");
    } else {
      themeLink.href =
        "https://unpkg.com/primereact/resources/themes/lara-light-blue/theme.css";
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  return (
    <BrowserRouter>

      <ScrollToTop />

      <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />

      <Routes>
       <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/trainings" element={<Trainings />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/copy-view-widget" element={<CopyViewWidgetPic />} />
        <Route path="/comments-filter" element={<FilterCommentsWidgetPic />} />
        <Route path="/glossary-widget" element={<GlossaryWidgetPic />} />
        <Route path="/file-gallery-widget" element={<FileGalleryWidgetPic />} />
        <Route path="/review-comments-widget" element={<ReviewCommentsWidgetPic />} />

        <Route path="/hosting" element={<Hosting />} />
      </Routes>

      <Footer />
      <ScrollTopButton />

    </BrowserRouter>
  );
}

export default App;
